import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppLayoutComponent } from './app-layout/app-layout.component';
import { AccountLayoutComponent } from './account-layout/account-layout.component';
import { SharedModule } from '../shared/shared.module';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { RouterModule } from '@angular/router';
import { LayoutRoutingModule } from './layout-routing.module';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [
    AppLayoutComponent,
    AccountLayoutComponent,
    NavMenuComponent
  ],
  imports: [
    LayoutRoutingModule,
    CommonModule,
    SharedModule,
    RouterModule,
    FlexLayoutModule
  ]
})
export class LayoutModule {
}
